import React, { FC } from 'react';
import styles from './search_filters_bar_item.module.scss';

export const SearchFilterBarItem: FC = ({ children }) => {
  return <div className={styles.item}>{children}</div>;
};
